import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { schoolActions } from '../actions/school.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class SchoolEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getSchool$ = createEffect(() => {
        return this.actions.pipe(
            ofType(schoolActions.getSchool),
            mergeMap(({ id }) => {
                return this.httpService.getSchool(id).pipe(
                    finalizeLoader('school-get'),
                    map((payload) => schoolActions.getSchoolSuccess({ payload })),
                    catchError(() => of(schoolActions.getSchoolError())),
                );
            }),
        );
    });

    getContactEmail$ = createEffect(() => {
        return this.actions.pipe(
            ofType(schoolActions.getContactEmail),
            mergeMap(() => {
                return this.httpService.getContactEmail().pipe(
                    map((payload) => schoolActions.getContactEmailSuccess({ payload })),
                    catchError(() => of(schoolActions.getContactEmailError())),
                );
            }),
        );
    });
}
